<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-tag-multiple"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mb-5">
        <v-col class="text-right" cols="12">
          <v-btn
              color="primary"
              @click="addTag"
          >
            Thêm Tags
          </v-btn>
        </v-col>
      </v-row>

      <v-row align="center" class="mt-n6 " justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="tags"
              :items-per-page="10"
              class="elevation-1">
            <template v-slot:item.color="{ item }">
              <v-row>
                <v-col cols="10" :style="{background:item.color}"></v-col>
              </v-row>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" small @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)"> mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {DELETE_TAG, GET_LIST_TAGS} from "@/store/modules/tags";


export default {
  name: "tag",
  data() {
    return {
      page: "Danh sách tags",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách tags",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
        },
        {text: 'Tên', value: 'name'},
        {text: 'Mô tả', value: 'description'},
        {text: 'Màu sắc', value: 'color', sortable: false},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
    }
  },
  computed: {
    ...mapGetters({
      tags: "tags",
    }),
  },
  async created() {
    await this.$store.dispatch(GET_LIST_TAGS);
  },
  methods: {
    addTag() {
      this.$router.push('/project_management/tags/add_tag')
    },
    editItem(id) {
      this.$router.push({
        path: "/project_management/tags/edit_tag/" + id,
      });
    },
    deleteItem(id) {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_TAG}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_TAGS);
        }
      })
    },
  }

}
</script>

<style scoped>

</style>